import { get } from 'lodash';
import React, { ChangeEvent, useMemo } from 'react';
import { Contact } from '~/types/models';
import cx from 'classnames';

interface ProfileFormRowProps {
  prop: keyof Contact;
  profileKey: string;
  placeholder: string;
  errorMessage?: string;
  label: string;
  onChange: (profileKey: string, value: string) => void;
  profile: Contact | null;
}

export default function ProfileFormRow({
  prop,
  profileKey,
  placeholder,
  errorMessage = '',
  label,
  onChange,
  profile,
}: ProfileFormRowProps) {
  function handleInputChange(e: ChangeEvent<HTMLInputElement>) {
    onChange(profileKey, e.target.value);
  }

  const hasError = useMemo(() => errorMessage !== '', [errorMessage]);

  return (
    <div className='mb-5'>
      <label
        className={cx('text-base mb-2.5', {
          'text-pink-900': hasError,
        })}
      >
        {label}
      </label>
      <input
        defaultValue={get(profile, prop) as string}
        name={prop}
        type='text'
        onChange={handleInputChange}
        placeholder={placeholder}
        className={cx(
          'w-full h-10 rounded border border-solid focus:outline-none py-3 pl-5',
          {
            'border-neutral focus:border-turquoise': !hasError,
            'border-pink-900': hasError,
          }
        )}
      />
      {errorMessage && (
        <span className='text-pink-900 mt-1 text-sm'>{errorMessage}</span>
      )}
    </div>
  );
}
